<template>
  <div class="hello">
      <transition name="fade">
        <div v-if="performingRequest" class="loading">
            <p>Logging In...</p>
        </div>
    </transition>

    <b-container>
        <b-row>
            <b-col>
                <h4>Login</h4>
            </b-col>
        </b-row>

        <b-input-group prepend="Email" class="mt-3">
            <b-form-input v-model="email"></b-form-input>
        </b-input-group>
        <b-input-group prepend="Password" class="mt-3">
            <b-form-input type="password"  v-model="password"></b-form-input>
        </b-input-group>
        <!-- Error message -->
        <b-row style="margin-top:10px">
            <b-col>
                <div style="color:red" v-if="errorMsg">{{errorMsg}}</div>
            </b-col>
        </b-row>

        <b-row style="margin-top:20px">
            <b-col>
                <b-button @click="login()" variant="info">Login</b-button>
                <b-button @click="closeLoginModal()" variant="outline-danger" style="margin-left:10px">Cancel</b-button>
            </b-col>
        </b-row>
        <!-- Forgot password -->
        <div style="color:grey; margin-top:10px">
            <a @click="resetPassword()">Forgot Password?</a>
        </div>



    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')

export default {    
    props: ['modalid'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {
            email:'',
            password:'',
            userIsLoggedIn:false,
            performingRequest:false,
            errorMsg:'',
        }
    },

    methods:{
        //Login user
        login(){
            this.performingRequest = true
            console.log("Signing in ")
            this.errorMsg = ""
            fb.auth.signInWithEmailAndPassword(this.email, this.password).then(user => {
                this.$store.commit('setCurrentUser', user.user)
                this.performingRequest = false
                this.userIsLoggedIn=true
                console.log("Logged in")
                this.closeLoginModal()

                    
            }).catch(err => {
                this.userIsLoggedIn=false
                console.log(err)
                this.performingRequest = false
                this.errorMsg = err.message
            })
        },

        //Close modal
        closeLoginModal(){
            this.$emit('closeLoginModal', this.modalid, this.userIsLoggedIn)
        },

        //Reset password
        resetPassword(){
            this.performingRequest = false
            this.$router.push({path:'/forgotpassword'})
        },
    },

    mounted(){
    },
}
</script>

